"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var QBAdapter_1 = require("../QBAdapter");
var types_1 = require("../types");
var voidStream_1 = require("../utils/voidStream");
exports.default = (function (get, Dialogs$, getTalker) {
    var removePermanent = effector_1.createEffect().use(function (dialogIds) {
        var dialogs = Dialogs$.getState();
        dialogIds.forEach(function (dialogId) {
            var dialog = dialogs[dialogId];
            if (dialog) {
                QBAdapter_1.sendSystemMessageEvent(getTalker(dialog), {
                    body: types_1.TSystemEvents.DELETE_GROUP,
                    extension: {
                        _id: dialogId,
                    },
                });
            }
        });
        return QBAdapter_1.deleteDialog(dialogIds, { force: 1 });
    });
    effector_1.forward({
        from: removePermanent.done.map(voidStream_1.voidStream),
        to: get,
    });
    return removePermanent;
});
//# sourceMappingURL=removePermanent.js.map